<template>
  <section>
    <div class="row">
      <div class="col-md-4">
        <button class="btn btn-link" @click="showMealPlans">Meal Plans</button>
      </div>
      <div class="col-md-4">
        <table>
          <tbody>
            <tr>
              <td align="center">
                <img src="/media/ic_rate_good.png" width="40" />
              </td>
              <td align="center">
                <img src="/media/ic_rate_neutral.png" width="40" />
              </td>
              <td align="center">
                <img src="/media/ic_rate_bad.png" width="40" />
              </td>
            </tr>
            <tr>
              <td
                align="center"
                style="font-size: 20pt; padding-left: 40px; padding-right: 40px"
              >
                {{ goodPct }}%
              </td>
              <td
                align="center"
                style="font-size: 20pt; padding-left: 40px; padding-right: 40px"
              >
                {{ neutralPct }}%
              </td>
              <td
                align="center"
                style="font-size: 20pt; padding-left: 40px; padding-right: 40px"
              >
                {{ badPct }}%
              </td>
            </tr>
            <tr>
              <td align="center" style="font-size: 12pt">
                {{ good }} of
                {{ count }}
              </td>
              <td align="center" style="font-size: 12pt">
                {{ neutral }} of
                {{ count }}
              </td>
              <td align="center" style="font-size: 12pt">
                {{ bad }} of
                {{ count }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-4"></div>
      <!-- <div class="col-md-8 custom-progress-gauge">
        <progress-gauge :progress="progress" :dontAnimate="true" :width="250" />
      </div> -->
    </div>
  </section>
  <client-mealplan-dialog
    :show="actionMealPlans"
    @close="closeDialog"
    @showMealPlan="showMealPlan"
  />
  <client-mealplan-image-dialog
    :show="actionMealPlanImage"
    @close="closeImageDialog"
  />
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ProgressGauge from '@/Components/UserCardio/elements/progress-gauge'
import ClientMealplanDialog from '../client-mealplan-dialog'
import ClientMealplanImageDialog from '../client-mealplan-image-dialog'
export default {
  name: 'nutrition-forweek',
  components: {
    ProgressGauge,
    ClientMealplanDialog,
    ClientMealplanImageDialog,
  },
  data() {
    return {
      actionMealPlans: null,
      actionMealPlanImage: null,
    }
  },
  mounted() {
    setTimeout(() => {
      window.app.$forceUpdate()
    })
  },
  computed: {
    ...mapGetters('nutrition', ['nutrition']),
    ...mapGetters('usercardio', ['member']),
    count() {
      let _data = null
      if (this.nutrition) {
        _data = this.nutrition.food.totals.count
      }
      return _data
    },
    bad() {
      let _data = null
      if (this.nutrition) {
        _data = this.nutrition.food.totals.bad
      }
      return _data
    },
    badPct() {
      let _data = null
      if (this.nutrition) {
        _data = this.nutrition.food.totals.badPct
      }
      return _data
    },
    good() {
      let _data = null
      if (this.nutrition) {
        _data = this.nutrition.food.totals.good
      }
      return _data
    },
    goodPct() {
      let _data = null
      if (this.nutrition) {
        _data = this.nutrition.food.totals.goodPct
      }
      return _data
    },
    neutral() {
      let _data = null
      if (this.nutrition) {
        _data = this.nutrition.food.totals.neutral
      }
      return _data
    },
    neutralPct() {
      let _data = null
      if (this.nutrition) {
        _data = this.nutrition.food.totals.neutralPct
      }
      return _data
    },
    progress() {
      let _data = null
      if (this.nutrition) {
        _data = [
          this.nutrition.food.totals.badPct,
          this.nutrition.food.totals.neutralPct,
          this.nutrition.food.totals.goodPct,
        ]
      }
      // console.log('Overall Food Progress', {
      //   nutrition: this.nutrition,
      //   data: _data,
      // })
      return _data
    },
  },
  methods: {
    ...mapActions('nutrition', ['getMealPlans']),
    closeDialog() {
      this.actionMealPlans = null
    },
    closeImageDialog() {
      this.actionMealPlanImage = null
    },
    async showMealPlans() {
      console.log('Show Meal Plans')
      await this.getMealPlans(this.member.id)
      this.actionMealPlans = true
    },
    showMealPlan(img) {
      console.log('Show Meal Plan Photo', img)
      this.actionMealPlanImage = img
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-progress-gauge {
  padding-top: 30px;
}
</style>
